<template lang="html">
  <div class="default-right-sidebar">
    <HelpBox v-if="portalId === 'AGRAVIS'" type="danger" large>
      <h2>Liebe KundInnen, ab 1. März 2025 finden Sie unsere Raiffeisen NetFarming Produkte sowie Ihre Flächen und Zonenkarten in Ackerprofi vor. </h2>

      <h2>Melden Sie sich hierfür unter <a href="https://www.ackerprofi.de/funktionen/precision-farming.html">www.ackerprofi.de</a> an.</h2>

      <h4>Bei Fragen wenden Sie sich an Ihren entsprechenden Vertriebspartner.</h4>
    </HelpBox>

    <HelpBox large>
      <h2>
        <IxRes>Areas.FieldRecordSystem.SR_FieldRecordSystem.welcomeTitleFrs</IxRes>
      </h2>
      <h4 class="lead">
        <IxRes>Areas.FieldRecordSystem.SR_FieldRecordSystem.frsVersion</IxRes>
      </h4>
      <p>
        <b>
          <IxRes>Areas.FieldRecordSystem.SR_FieldRecordSystem.frsFirstSteps</IxRes>
        </b>
      </p>
      <p>
        <IxRes>Areas.FieldRecordSystem.SR_FieldRecordSystem.frsWelcomeInfo</IxRes>
      </p>
    </HelpBox>
  </div>
</template>

<script>
import {config} from 'src/js/infrastructure'

import HelpBox from '@components/help/HelpBox'

export default {
  components: {
    HelpBox
  },
  computed: {
    portalId () {
      return config.portalId
    }
  }
}
</script>

<style lang="scss" scoped>
.default-right-sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
